<script setup lang="ts">
import { useToastNotificationStore } from "@/stores/toastNotificationStore";
import { Toast } from "@/types/toast";
import ToastCloseIcon from "@/components/notifications/ToastCloseIcon.vue";
import SuccessNotificationIcon from "@/components/notifications/SuccessNotificationIcon.vue";
import ErrorNotificationIcon from "@/components/notifications/ErrorNotificationIcon.vue";
import WarningNotificationIcon from "@/components/notifications/WarningNotificationIcon.vue";
import InfoNotificationIcon from "@/components/notifications/InfoNotificationIcon.vue";

const notificationStorage = useToastNotificationStore();

function removeToast(id: number) {
  notificationStorage.removeNotification(id);
}

function getToastClasses(toast: Toast) {
  switch (toast.type) {
    case "error":
      return "bg-red-700 text-red-50";
    case "success":
      return "bg-green-700 text-green-50";
    default:
      return "bg-yellow-500 text-yellow-50";
  }
}

function getToastIcon(toast: Toast) {
  switch (toast.type) {
    case "error":
      return ErrorNotificationIcon;
    case "success":
      return SuccessNotificationIcon;
    case "warning":
      return WarningNotificationIcon;
    case "info":
      return InfoNotificationIcon;
  }
}
</script>

<template>
  <Teleport to="body">
    <!-- NOTIFICATIONS CONTAINER -->
    <div
      class="fixed top-6 right-6 z-[9999] w-[360px] max-w-[92vw] pointer-events-none"
    >
      <TransitionGroup
        name="toast"
        tag="div"
        move-class="transition-all duration-300"
        class="flex flex-col gap-y-3"
      >
        <div
          v-for="toast in notificationStorage.notifications"
          :key="toast.id"
          class="flex items-center gap-3 rounded-lg p-4"
          :class="getToastClasses(toast)"
        >
          <component :is="getToastIcon(toast)" class="h-full aspect-square" />
          <!-- Текст -->
          <div class="flex-1 text-sm font-medium">
            {{ toast.text }}
          </div>

          <ToastCloseIcon
            class="cursor-pointer size-5 pointer-events-auto"
            @click="removeToast(toast.id)"
          />
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.5s ease;
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateY(8px);
}

@keyframes toast-in-out {
  0% {
    opacity: 0;
    transform: translateY(8px);
  }
  5% {
    opacity: 1;
    transform: translateY(0);
  }
  90% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-8px);
  }
}
</style>
